import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { faqs } from "../mock/mock";
import { HelpCircle } from "lucide-react";

const FAQ = () => {
  return (
    <div>
      <div className="bg-ep-royal py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
          <div className="text-[#ff5a5a] font-semibold tracking-widest text-xs uppercase">FAQ</div>
          <h1 className="text-white text-4xl sm:text-5xl font-bold mt-3">Frequently asked questions</h1>
          <p className="mt-4 text-white/70 max-w-2xl mx-auto">
            Everything you need to know about how Explorer Picks works, what
            you’ll receive as a member, and how we operate.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-5 lg:px-8 py-16">
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white border border-slate-200 rounded-2xl px-5 shadow-sm"
            >
              <AccordionTrigger className="text-left hover:no-underline py-5">
                <div className="flex items-start gap-3 pr-4">
                  <HelpCircle size={20} className="text-[#ff5a5a] mt-0.5 flex-shrink-0" />
                  <span className="font-semibold text-[#0a1a4a]">{f.q}</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-[#0a1a4a]/75 leading-relaxed pb-5 pl-8">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;
